import { getLabel } from "@/lib/labels/getLabel";
import type { Labels } from "@/lib/labels/types";

const CODE_TO_LABEL: Record<string, string> = {
    "auth/invalid-credential": "invalidCredentials",
    "auth/wrong-password": "invalidCredentials",
    "auth/user-not-found": "invalidCredentials",
    "auth/email-already-in-use": "emailInUse",
    "auth/invalid-email": "invalidEmail",
    "auth/weak-password": "weakPassword",
    "auth/too-many-requests": "tooManyRequests",
    "auth/network-request-failed": "network",
    "auth/user-disabled": "userDisabled",
    "auth/popup-blocked": "popupBlocked",
};

// The user dismissed the Google popup themselves — nothing to report.
const SILENT_CODES = new Set(["auth/popup-closed-by-user", "auth/cancelled-popup-request"]);

/**
 * Maps an auth error to a user-facing, localized message. Returns null when the error
 * needs no feedback. Raw Firebase messages are never shown.
 */
export function getAuthErrorMessage(err: unknown, labels: Labels): string | null {
    const code = typeof err === "object" && err !== null ? (err as { code?: unknown }).code : undefined;
    if (typeof code === "string" && SILENT_CODES.has(code)) return null;
    const labelKey = (typeof code === "string" && CODE_TO_LABEL[code]) || "generic";
    return getLabel(labels, `auth.errors.${labelKey}`);
}
